import axios from 'axios'
import baseUrl from './baseUrl'

export const graphQlUrl = baseUrl('4001', 'api', 'graphql?')

const HTTP = axios.create({
  baseURL: graphQlUrl
})

export default HTTP
